import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SedeEmpresa } from '@app/shared';
import { HttpClient } from '@angular/common/http';
import { EndpointService, AuthenticationService } from '@app/core';

@Injectable()
export class ManagementSystemDataService {

  constructor(
    private http: HttpClient,
    private api: EndpointService,
    private as: AuthenticationService) { }

  /**
   * Obtener id de la empresa según usuario logueado
   *
   * @returns
   * @memberof ManagementSystemDataService
   */
  idSelectCompany() {
    return this.as.getCredentials(true).info_persona.id_empresa;
  }

  /**
   * Obtener todas las sedes
   *
   * @returns {Observable<Sede[]>}
   * @memberof ManagementSystemDataService
   */
  getSedes(idCompany: number): Observable<SedeEmpresa[]> {
    return new Observable(obs => {
      this.http.get<SedeEmpresa[]>(this.api.get('sedesManagement', [idCompany])).subscribe(
        sedesManagement => obs.next(sedesManagement),
        err => obs.error(err)
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/shared/management-system-data.service.ts